// extracted by mini-css-extract-plugin
export var breadcrumbs = "BreadCrumbs-module--breadcrumbs--f7ddc";
export var spacer = "BreadCrumbs-module--spacer--95034";
export var crumb = "BreadCrumbs-module--crumb--3257d";